import React from 'react';
import PropTypes from 'prop-types';
import hansepayMark from '../../assets/hansepaylogo.png';

function HansePayLogoSpinner({ variant }) {
  const isSplash = variant === 'splash';

  return (
    <div className='hp-loader-mark' aria-hidden='true'>
      <svg className='hp-loader-mark__svg' viewBox='0 0 96 96' width='96' height='96' xmlns='http://www.w3.org/2000/svg'>
        <circle className='hp-loader-mark__track' cx='48' cy='48' r='42' fill='none' strokeWidth='2' />
      </svg>
      <svg className='hp-loader-mark__svg hp-loader-mark__arc' viewBox='0 0 96 96' width='96' height='96' xmlns='http://www.w3.org/2000/svg'>
        <circle
          className='hp-loader-mark__spinner'
          cx='48'
          cy='48'
          r='42'
          fill='none'
          strokeWidth='2'
          strokeLinecap='round'
          strokeDasharray='66 198'
          transform='rotate(-90 48 48)'
        />
      </svg>
      <img
        src={hansepayMark}
        width='38'
        height='38'
        alt=''
        className={`hp-loader-mark__logo ${isSplash ? 'hp-loader-mark__logo--splash' : ''}`}
      />
    </div>
  );
}

HansePayLogoSpinner.propTypes = {
  variant: PropTypes.oneOf(['splash', 'inline']).isRequired,
};

function HansePayLoader({ variant = 'inline', showLabel, minHeight, className, label = 'HansePay' }) {
  const isSplash = variant === 'splash';
  const shouldShowLabel = showLabel ?? isSplash;
  const resolvedMinHeight = minHeight ?? (isSplash ? '100vh' : '30vh');

  return (
    <div
      className={`hp-loader hp-loader--${variant} ${className || ''}`.trim()}
      style={{ minHeight: resolvedMinHeight }}
      role='status'
      aria-live='polite'
      aria-label={shouldShowLabel ? `Loading ${label}` : 'Loading'}
    >
      <div className='hp-loader__content'>
        <HansePayLogoSpinner variant={variant} />
        {shouldShowLabel && <p className='hp-loader__label'>{label}</p>}
      </div>
    </div>
  );
}

HansePayLoader.propTypes = {
  variant: PropTypes.oneOf(['splash', 'inline']),
  showLabel: PropTypes.bool,
  minHeight: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
};

HansePayLoader.defaultProps = {
  variant: 'inline',
  showLabel: undefined,
  minHeight: undefined,
  className: '',
  label: 'HansePay',
};

export default HansePayLoader;
